// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const corviknight: PokeData = {
  "id": 823,
  "name": "corviknight",
  "height": 22,
  "weight": 750,
  "base_experience": 248,
  "types": [
    PokeType.FLYING,
    PokeType.STEEL
  ],
  "api_moves": [
    "fury-attack",
    "leer",
    "peck",
    "drill-peck",
    "screech",
    "scary-face",
    "swagger",
    "steel-wing",
    "taunt",
    "metal-sound",
    "iron-defense",
    "pluck",
    "brave-bird",
    "hone-claws",
    "power-trip"
  ],
  "moves": [
    "leer",
    "peck",
    "scary-face",
    "metal-sound",
    "brave-bird",
    "iron-defense",
    "roost",
    "acrobatics",
    "steel-beam",
    "behemoth-bash",
    "gust",
    "metal-claw",
    "gear-up"
  ],
  "evolution_chain": {
    "id": 434,
    "item": null,
    "species": [
      {
        "name": "rookidee",
        "order": 821,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "corvisquire",
        "order": 822,
        "types": [
          PokeType.FLYING
        ],
        "evolves_from_species_id": 821,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "corviknight",
        "order": 823,
        "types": [
          PokeType.FLYING,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 822,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 38,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 154,
    "speed": 107,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
